let util = {};

util.formatCodeset = function(val, codeSet) {
  var res = "未知";
  for (let index in codeSet) {
    if (codeSet[index].itemCode == val) {
      res = codeSet[index].itemName;
      break;
    }
  }
  return res;
};

//将时间戳转换为日期格式 yyyy-MM
util.formatMonth = function(timeStamp) {
  if (timeStamp == null || timeStamp === "") {
    return "";
  }
  let date = new Date(timeStamp);
  let month = date.getMonth() + 1;
  if (month < 10) {
    month = "0" + month;
  }
  return date.getFullYear() + "-" + month;
};

//将时间戳转换为日期格式 yyyy-MM-dd
util.formatDate = function(timeStamp) {
  if (timeStamp == null) {
    return "";
  }

  let date = new Date(timeStamp);
  let month = date.getMonth() + 1;
  if (month < 10) {
    month = "0" + month;
  }
  let day = date.getDate();
  if (day < 10) {
    day = "0" + day;
  }
  return date.getFullYear() + "-" + month + "-" + day;
};
//将时间戳转换为日期格式 yyyy.MM.dd
util.formatDateTwo = function(timeStamp) {
  if (timeStamp == null) {
    return "";
  }

  let date = new Date(timeStamp);
  let month = date.getMonth() + 1;
  if (month < 10) {
    month = "0" + month;
  }
  let day = date.getDate();
  if (day < 10) {
    day = "0" + day;
  }
  return date.getFullYear() + "." + month + "." + day;
};
//将时间戳转换为日期格式 yyyy-MM-dd hh:mm:ss
util.formatDateTime = function(timeStamp) {
  //shijianchuo是整数，否则要parseInt转换
  function add0(m) {
    return m < 10 ? "0" + m : m;
  }
  var time = new Date(timeStamp);
  var y = time.getFullYear();
  var m = time.getMonth() + 1;
  var d = time.getDate();
  var h = time.getHours();
  var mm = time.getMinutes();
  var s = time.getSeconds();
  return (
    y +
    "-" +
    add0(m) +
    "-" +
    add0(d) +
    " " +
    add0(h) +
    ":" +
    add0(mm) +
    ":" +
    add0(s)
  );
};
/**
 * 将日期字符串转为Date类型
 * @param {*} str  yyyy-MM-dd
 */
util.stringToDate = function(str) {
  var dateStrs = str.split("-");
  var year = parseInt(dateStrs[0], 10);
  var month = parseInt(dateStrs[1], 10) - 1;
  var day = parseInt(dateStrs[2], 10);
  var date = new Date(year, month, day);
  return date;
};

util.numNull = function(num) {
  if (!num || num == null || num == undefined) {
    return 0;
  }
  return num * 1;
};

util.isNum = function(value) {
  console.log(value);
  if (value === undefined || value === null || value === "") {
    return false;
  }

  if (typeof value === "string") {
    //正整数
    var reNumber = /^\d+$/;
    //负整数
    var reNeNumber = /^-\d+$/;
    //正实数
    var reRealNumber1 = /^[1-9]\d*[.]\d+$/; //非零开头
    var reRealNumber2 = /^0[.]\d+$/; //零开头
    //负实数
    var reNeRealNumber1 = /^-[1-9]\d*[.]\d+$/; //非零开头
    var reNeRealNumber2 = /^-0[.]\d+$/; //零开头

    if (
      reNumber.test(value) ||
      reNeNumber.test(value) ||
      reRealNumber1.test(value) ||
      reRealNumber2.test(value) ||
      reNeRealNumber1.test(value) ||
      reNeRealNumber2.test(value)
    ) {
      return true;
    } else {
      return false;
    }
  } else if (typeof value === "number") {
    return true;
  } else {
    return false;
  }
};


/**
 * @description 空值，没有正常返回数字时进行转换
 * emptyFormat
 * @param {any} value
 * @param {any} formatText 空值时转换成 formatText
 */
util.emptyFormat = (value, formatText = "- - -") => {
  if (/^$|undefined|null/.test(value)) {
    return formatText;
  }
  return value;
};

util.isEmpty = function(obj) {
  if (typeof obj == "undefined" || obj == null || obj == "") {
    return true;
  } else {
    return false;
  }
};
util.isPhone = function(phone) {
  var myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
  if (!myreg.test(phone)) {
    return false;
  } else {
    return true;
  }
};

/**
 * 获取指定n天前的日期
 * @param {*} number
 */
util.getBeforeDate = function(number) {
  var time = new Date().getTime() - number * 24 * 60 * 60 * 1000;
  var tragetTime = new Date(time);
  tragetTime =
    tragetTime.getFullYear() +
    "-" +
    (tragetTime.getMonth() > 8
      ? tragetTime.getMonth() + 1
      : "0" + (tragetTime.getMonth() + 1)) +
    "-" +
    (tragetTime.getDate() > 9
      ? tragetTime.getDate()
      : "0" + tragetTime.getDate());
  // console.log(tragetTime, "这是一周前日期，格式为2010-01-01");
  return tragetTime;
};

//金额格式化
util.amount = function(strData, n) {
  var CurrencyAndAmountRegExp = /^(\d{1,18})|(\d{1,18}\.)|(\d{1,17}\.\d{0,1})|(\d{1,16}\.\d{0,2})|(\.\d{1,2})$/;
  var _result = CurrencyAndAmountRegExp.test(strData);

  if (_result == false) {
    return strData;
  }
  // 一般来说最多就6位吧，当然如果有特殊需求可自行更改(｀・∀・´)
  n = n > 0 && n <= 6 ? n : 2;
  var formatData =
    parseFloat((strData + "").replace(/[^\d.-]/g, "")).toFixed(n) + "";
  var l = formatData
    .split(".")[0]
    .split("")
    .reverse();
  var r = formatData.split(".")[1];
  var t = "";
  for (let i = 0; i < l.length; i++) {
    t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? "," : "");
  }
  return (
    t
      .split("")
      .reverse()
      .join("") +
    "." +
    r
  );
};

/**
 * @description 获取单个值集对应的name
 * @param codeArr 单个值集array
 * @param code    编码
 * @returns 转译后的名称（没有转译成功，返回编码）
 */
util.getCodeNameByCode = function(codeArr, code) {
  var val = code;
  if (codeArr && codeArr.length) {
    for (var i = 0; i < codeArr.length; i++) {
      var item = codeArr[i];
      if (item.itemCode == code) {
        val = item.itemName;
        break;
      }
    }
  }
  return val;
};
  /**
   * 过滤小数点位数--
   * @param {*} value
   */
  
util.poidNumber = function (value) {
  if (value == null || value == "" || value == undefined) {
      return value;
    }
    const x = String(value).indexOf('.') + 1; // 小数点的位置
    const y = String(value).length - x; // 小数的位数
    if (value && y > 4 && x > 0) {
      return Math.floor(parseFloat(value) * 10000) / 10000
    }
    return value
};


util.formatName = function(name){
    let newStr;
    if (name.length === 2) {
    newStr = name.substr(0, 1) + '*';
    } else if (name.length > 2) {
      let char = '';
      for (let i = 0, len = name.length - 2; i < len; i++) {
        char += '*';
      }
      newStr = name.substr(0, 1) + char + name.substr(-1, 1);
    } else {
      newStr = name;
    }

    return newStr;
}

/**
 * base64转二进制流
 */
util.base64ToNeed = function (type, base64) {
  let arr = base64.split(',');
  const binaryString = window.atob(arr[1]);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  const mime = arr[0].match(/:(.*?);/)[1];
  const ext = mime.split('/')[1];

  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  if (type === 'binary') {
    return bytes;
  }
  if (type === 'file') {
    return new File([bytes], `file.${ext}`);
  }
  if (type === 'formData') {
    const formData = new FormData();
    formData.append('file', new File([bytes], `file.${ext}`));
    return formData
  }
}

export default util;
